import React, {FC} from 'react'
import { arrTechnologies } from '../../utils/data'
import styles from './SliderTechnologies.module.scss'
import { v4 as uuidv4 } from 'uuid'


export const SliderTechnologies:FC = () => {

    return (
            <div className={styles.container}>
                    <div className={styles.items_wrap}>
                        <ul className={`${styles.items} ${styles.marquee}`}>
                            {arrTechnologies.map(item => {
                                const keyUid = uuidv4()
                                return(
                                    <li className={styles.item} key={keyUid}>
                                        <img className={styles.icon} src={item.image} alt='лого'/>
                                    </li>
                                )
                            })}
                        </ul>
                        <ul className={`${styles.items} ${styles.marquee}`} aria-hidden="true">
                            {arrTechnologies.map(item => {
                                const keyUid = uuidv4()
                                return(
                                    <li className={styles.item} key={keyUid}>
                                        <img className={styles.icon} src={item.image} alt='лого'/>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
            </div>
    )
}